import { useEffect, useState } from 'react';

/**
 * `true` abajo de 640px — el breakpoint `sm` de Tailwind.
 *
 * Es el corte que usan las superficies "de teléfono" de la app (el hero del inicio, el
 * sheet de Generar, los títulos de página), así que una pantalla que tiene que ELEGIR
 * entre dos componentes según el dispositivo —y no sólo mostrarlos u ocultarlos con
 * CSS— tiene que preguntar por este mismo ancho. Con `useIsDesktop` (1024px) quedaría
 * una franja de 640 a 1024 montando el componente de mobile, que ahí es `sm:hidden`:
 * invisible, y el tap sin efecto.
 *
 * Reactivo: se actualiza al cruzar el breakpoint (resize / rotación).
 */
const QUERY = '(max-width: 639px)';

export function useEsMobile(): boolean {
  const [esMobile, setEsMobile] = useState(
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(QUERY).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(QUERY);
    const onChange = () => setEsMobile(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return esMobile;
}

export default useEsMobile;
